define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function ReadOnlyDirectoryFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    ReadOnlyDirectoryFail.WEB_BACKEND_ERROR = 'read_only';

    ReadOnlyDirectoryFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: ReadOnlyDirectoryFail,
        className: 'ReadOnlyDirectoryFail',
        radarName: 'fail_{SOURCE}_read-only-folder',
        message: [
            'Папка доступна только для чтения.',
            '<a href="https://help.mail.ru/cloud_web/folders/public" rel="noopener" target="_blank">Подробнее</a>',
        ].join(' '),
    });

    module.exports = ReadOnlyDirectoryFail;
});
